const GET_DELIVERY_NOTES_REQUEST = 'GET_DELIVERY_NOTES_REQUEST';
const GET_DELIVERY_NOTES_SUCCESS = 'GET_DELIVERY_NOTES_SUCCESS';
const GET_DELIVERY_NOTES_ERROR = 'GET_DELIVERY_NOTES_ERROR';

const GET_DELIVERY_NOTE_REQUEST = 'GET_DELIVERY_NOTE_REQUEST';
const GET_DELIVERY_NOTE_SUCCESS = 'GET_DELIVERY_NOTE_SUCCESS';
const GET_DELIVERY_NOTE_ERROR = 'GET_DELIVERY_NOTE_ERROR';

const UPDATE_DELIVERY_NOTE_REQUEST = 'UPDATE_DELIVERY_NOTE_REQUEST';
const UPDATE_DELIVERY_NOTE_SUCCESS = 'UPDATE_DELIVERY_NOTE_SUCCESS';
const UPDATE_DELIVERY_NOTE_ERROR = 'UPDATE_DELIVERY_NOTE_ERROR';

const CLEAR_DELIVERY_NOTES_STATE = 'CLEAR_SCANNED_DOCUMENTS_STATE';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
const INIT_REDUCER = 'INIT_REDUCER';
const CREATE_ERRORS = 'CREATE_ERRORS';

export {
  GET_DELIVERY_NOTES_REQUEST,
  GET_DELIVERY_NOTES_SUCCESS,
  GET_DELIVERY_NOTES_ERROR,
  CLEAR_DELIVERY_NOTES_STATE,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  CREATE_ERRORS,
  INIT_REDUCER,
  GET_DELIVERY_NOTE_ERROR,
  GET_DELIVERY_NOTE_REQUEST,
  GET_DELIVERY_NOTE_SUCCESS,
  UPDATE_DELIVERY_NOTE_REQUEST,
  UPDATE_DELIVERY_NOTE_SUCCESS,
  UPDATE_DELIVERY_NOTE_ERROR,
};
